export enum StorefrontInsertPosition {
  After = "after",
  Before = "before",
  Prepend = "prepend",
  Append = "append",
}
